import { City } from '../city';
import { JobLocation } from '../jobLocation';

export interface Targeting {
  accountId: string;
  externalCampaignId?: string;
  targetingType: TargetingType;
  criteria: TargetingGroup | TargetingField;
}

export interface TargetingGroup {
  operator: TargetingGroupOperator;
  criteria: TargetingGroup[] | TargetingField[];
}

export interface TargetingField {
  operator: TargetingFieldOperator;
  field: TargetingKnownField;
  values: TargetingFieldValue[];
}

export enum TargetingType {
  All = 'ALL',
  Rules = 'RULES',
  PostingIds = 'POSTINGIDS',
}

export type TargetingGroupOperator = 'AND' | 'OR';
export type TargetingFieldOperator =
  | 'EQUALS'
  | 'DOESNOTEQUAL'
  | 'CONTAINS'
  | 'DOESNOTCONTAIN';

export interface TargetingFieldValue {
  id: string; // only required field
  name?: string; // e.g. brand name, location name (not required)
  city?: string; // TargetingKnownField === 'City' -> city & stateProvCode are required
  stateProvCode?: string; // the 2 digit state code
  number?: string; // location number when TargetingKnownField === 'LocationId' (not required)
}

export enum TargetingKnownField {
  BrandId = 'BrandId',
  City = 'City',
  ExternalRequisitionId = 'ExternalRequisitionId',
  JobDescription = 'JobDescription',
  JobTitle = 'JobTitle',
  LocationId = 'LocationId',
  PostalCode = 'PostalCode',
  PostingId = 'PostingId',
  StateProvCode = 'StateProvCode',
}

// DEPRECATED MODEL
export class Brand {
  accountId: string;
  id: string;
  logoMediaId: string;
  name: string;
}

export interface TargetingDeprecated {
  accountId: string;
  postingIds: string[];
  externalRequisitionIds: string[];
  jobTitleKeywords: string[];
  cities: City[];
  stateProvCodes: string[];
  postalCodes: string[];
  brandIds: string[];
  jobLocationIds: string[];
  brands: Brand[];
  jobLocations: JobLocation[];
  jobDescKeywords: string[];
}
